import HTTPService from '../../HTTPService'
import Model from '../../../../utils/Model'
import AuthUpdatePayloadCast from './AuthUpdatePayloadCast'

class Auth extends Model {
  csrfCookie () {
    return HTTPService.get('auth/csrf-cookie')
  }

  me () {
    return HTTPService.get('auth/me')
  }

  login ({ email, password, remember }) {
    return HTTPService.post('auth/login', {
      email,
      password,
      remember
    })
  }

  logout () {
    return HTTPService.post('auth/logout')
  }

  register ({ name, email, password }) {
    return HTTPService.post('auth/register', {
      name,
      email,
      password
    })
  }

  verify (base64URL) {
    return HTTPService.get(atob(base64URL))
  }

  verifyResend () {
    return HTTPService.post('auth/verify/resend')
  }

  update (payload) {
    payload = this.preparePayloadByCast(payload, AuthUpdatePayloadCast)
    if (payload) return HTTPService.put('auth/me', payload)
  }

  forgot (payload) {
    return HTTPService.post('auth/password/forgot', {
      email: payload.email
    })
  }

  reset (payload) {
    return HTTPService.post('auth/password/reset', {
      email: payload.email,
      token: payload.token,
      password: payload.password
    })
  }
}

export default new Auth()
